// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"525":"80acb413","793":"5d6e5c6b","998":"365b03a4"}[chunkId] + ".chunk.js";
};